/**
 * Created by Gustavo on 08/06/2016.
 */

import {Injectable}      from '@angular/core';
import {AuthHttpService} from './auth-http.service';
import {AppDataService} from "./app-data.service";
import * as firebase from 'firebase';

declare var Swal : any;

@Injectable()
export class QuestsService {
    constructor(private _authHttp : AuthHttpService, private _appData : AppDataService) {
      // Initialize Firebase
      var config = {
        apiKey: "AIzaSyBt_xy2toHw8Z31ItiZgPUnahcaHERfSr8",
        authDomain: "coolkids-669fa.firebaseapp.com",
        databaseURL: "https://coolkids-669fa.firebaseio.com",
        projectId: "coolkids-669fa",
        storageBucket: "coolkids-669fa.appspot.com",
        messagingSenderId: "159459566585"
      };
      try {
        firebase.initializeApp(config);
      }
      catch (err){
        //already connected
      }

    }

    ///////////////////YOUTUBE LIVECHAT//////////////////////////
    public getQuest(id){
      return firebase.firestore().collection('quests').doc(id);
    }
    public insertQuest(quest){
      return firebase.firestore().collection('quests').doc(quest.id).set(quest);
    }
    public getUserJournal(uid){
      return firebase.firestore().collection('user_quests').doc(uid).collection(`quests`);
    }
    public insertJournalQuest(journal){
      return firebase.firestore().collection('user_quests').doc(journal.userId).collection('quests').doc(journal.id).set(journal);
    }
    
  }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/quest.service.ts